import React from "react";
import "./Footer.scss";
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";
import NavbarLogo from "../../../assets/images/EconSignLogo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        {/* --- Brand Column --- */}
        <div className="footer__col footer__col--brand">
          <img src={NavbarLogo} alt="EconSign Logo" className="footer__logo" />
          <p className="footer__description">
            EconSign Soft is a software development company with a full cycle of
            services. For over 10 years, we have been helping enterprises around
            the world transform their business by creating effective digital
            solutions with the use of innovative technologies.
          </p>
          <div className="footer__social-wrapper">
            <a href="https://facebook.com/econsignsoft" target="_blank" rel="noreferrer" className="social-icon fb"><FaFacebookF /></a>
            <a href="https://linkedin.com/company/econsignsoft" target="_blank" rel="noreferrer" className="social-icon li"><FaLinkedinIn /></a>
            <a href="https://instagram.com/_econsignsoft_/" target="_blank" rel="noreferrer" className="social-icon ig"><FaInstagram /></a>
            <a href="https://x.com/econsignsoft" target="_blank" rel="noreferrer" className="social-icon tw"><FaXTwitter /></a>
          </div>
        </div>

        {/* --- Links Column --- */}
        <div className="footer__col footer__col--links">
          <h4 className="footer__widget-title">IT Services</h4>
          <ul className="footer__nav-list">
            <li><Link to="/software-development">Software Development</Link></li>
            <li><Link to="/web-development">Web Development</Link></li>
            <li><Link to="/fullstack-development">Full Stack Development</Link></li>
            <li><Link to="/app-development">App Development</Link></li>
            <li><Link to="/uiux-development">UI/UX Design</Link></li>
          </ul>
        </div>

        {/* --- Contact Column --- */}
        <div className="footer__col footer__col--contact">
          <h4 className="footer__widget-title">Get In Touch</h4>
          <div className="contact-info">
            <div className="contact-info__item">
              <FaMapMarkerAlt className="icon" />
              <address>F3, Sai Shraddha Society, Kondhwa, Pune, India</address>
            </div>
            
            {/* Clickable Phone */}
            <a href="tel:+912067622438" className="contact-info__item clickable">
              <FaPhoneAlt className="icon" />
              <span>(+91) 20-67622438</span>
            </a>

            {/* Clickable Email */}
            <a href="mailto:support@econsignsoft.com" className="contact-info__item clickable">
              <FaEnvelope className="icon" />
              <span>support@econsignsoft.com</span>
            </a>

            <div className="contact-info__item">
              <FaClock className="icon" />
              <span>09:30 AM - 06:30 PM</span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__copyright">
        <p>© {new Date().getFullYear()} <strong>EconSign Soft</strong>. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;